import loadLabels from './load-labels';

export default {
	loadLabels
};
